import { createFileRoute, redirect } from '@tanstack/react-router'

import { PriorityConfigPage } from '@/pages/priority-config/PriorityConfig.page'
import { getIsPlatformAdmin } from '@/stores/authUser.store'

export const Route = createFileRoute('/_auth/priority-config')({
  beforeLoad: () => {
    if (!getIsPlatformAdmin()) {
      throw redirect({
        to: '/recents',
        replace: true,
      })
    }
  },
  component: PriorityConfigPage,
  loader: () => ({ breadcrumbTitle: 'Project Priority Configuration' }),
})
